import { ToastrService } from 'ngx-toastr';
import { Component, Injectable, ViewContainerRef } from '@angular/core';

@Injectable()
export class ToasterComponent {
    public constructor(public toastr: ToastrService) {

    }

    success(msg, vcr: ViewContainerRef) {
        try {
            /* this.toastr.setRootViewContainerRef(vcr);
            this.toastr.success('<span style="color: white">' + msg + '</span>', null, { enableHTML: true }) */
            this.toastr.success('<span style="color: white">' + msg + '</span>', null,
            { enableHtml: true });
        } catch (e) {
            console.log('error in toastr : ' + e);
        }

    }

    error(msg, vcr: ViewContainerRef) {
        try {
            /* this.toastr.setRootViewContainerRef(vcr);
            this.toastr.error('<span style="color: white">' + msg + '</span>', null, { enableHTML: true }) */
            this.toastr.error('<span style="color: white">' + msg + '</span>', null,
            { enableHtml: true });
        } catch (e) {
            console.log('error in toastr : ' + e);
        }
    }

    warning(msg, vcr: ViewContainerRef) {
        try {
            /* this.toastr.setRootViewContainerRef(vcr);
            this.toastr.warning('<span style="color: white">' + msg + '</span>', null, { enableHTML: true }) */
            this.toastr.warning('<span style="color: white">' + msg + '</span>',
            null, { enableHtml: true });
        } catch (e) {
            console.log('error in toastr : ' + e);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/toasterComponent.ts